<!-- Search bar component template -->
<div :class="$style.searchContainer +' '+ className" :style="componentStyles">
    <MdIconSearch color="spirits--600" :data-qa-id="`${customClass}-search-icon`" @click="handleSearch"></MdIconSearch>
    <div :class="$style.searchInputContainer">
        <input
            :class="$style.inputField"
            :placeholder="placeholder" 
            v-model="searchValue"
            @keyup.enter="handleSearch" 
            @keyup.delete="handleEmptySearch($event)"
            :data-qa-id="`${customClass}-search-input`"
        >
        <MdIconClose 
            v-if="searchValue"
            :class="$style.inputCrossIcon" 
            :data-qa-id="`${customClass}-search-cross-icon`" 
            icontitle="disabled" 
            color="spirits--600" 
            as="button" 
            @handleiconclick="clearSearch"
        ></MdIconClose>
    </div>
</div>
